/**
 * Detects Next.js App Router console/RUM errors from a failed soft-nav RSC fetch.
 * Used by Datadog RUM beforeSend so framework noise does not inflate Error Tracking.
 *
 * Note: next@15.5.x already aborts in-flight RSC fetches on `pagehide` (PR #73975);
 * remaining events are typically network/cancel races that still log the message below.
 *
 * Post-deploy verification (PASGF-2712 / AC2):
 * - Error Tracking issue 3a6b5090: compare 7d count vs ~121/week baseline
 * - RUM: fewer `@resource.url:*_rsc*` with status_code:0 on /payment and /pdf
 */
export const isRscPayloadFetchError = (message: unknown): boolean => {
  if (typeof message !== "string") {
    return false;
  }
  return message.includes("Failed to fetch RSC payload");
};
